import * as React from 'react'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialAction from '@mui/material/SpeedDialAction'
import Fab from '@mui/material/Fab'
import LaunchGrid from './LaunchGrid'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import SchoolIcon from '@mui/icons-material/School'

// The two launchers in the word-cloud chrome, both fed by the app shell's
// action registry rather than by a callback per feature:
//   • the Views dial (blue) — the content views;
//   • the Learn button (emerald) — a full-screen grid of practice, lessons,
//     material and profile.
const LEARN_GROUPS = ['Practice', 'Lessons', 'Add material', 'You']

export default function HallucinationButton({ actions = [] }) {
  const [gridOpen, setGridOpen] = React.useState(false)

  // "Word cloud" is where we already are, so it's left out of the dial.
  const viewActions = actions.filter(a => a.group === 'Views' && a.id !== 'cloud')
  const learnActions = actions.filter(a => LEARN_GROUPS.includes(a.group))

  return (
    <>
      <SpeedDial
        direction="up"
        ariaLabel="SpeedDialViews"
        icon={<PlayArrowIcon />}
        FabProps={{ sx: fabSx('#2563eb', '#1d4ed8') }}>
        {viewActions.map((action) => (
          <SpeedDialAction key={action.id} icon={action.icon} tooltipTitle={action.name} onClick={action.onClick} />
        ))}
      </SpeedDial>
      {/* A bare Fab that opens the full-screen grid.
          - pointerEvents: the HUD row inherits `pointer-events: none`; MUI's
            SpeedDial re-enables it on its own Fab, a bare Fab has to as well.
          - alignSelf: the row is `align-items: stretch` and a `direction="up"`
            SpeedDial reserves height for its hidden actions, so an unstretched
            Fab would sit at the TOP of that tall row.
          - zIndex matches theme.zIndex.speedDial (1050). */}
      <Fab aria-label="Learn" title="Learn"
        sx={{ ...fabSx('#059669', '#047857'), pointerEvents: 'auto', zIndex: 1050, alignSelf: 'flex-end' }}
        onClick={() => setGridOpen(true)}>
        <SchoolIcon />
      </Fab>
      {gridOpen && (
        <LaunchGrid title="Learn" subtitle="Pick one to open it." actions={learnActions} onClose={() => setGridOpen(false)} />
      )}
    </>
  )
}

// Shared Fab colouring for the floating menu buttons — solid colour, a slightly
// darker shade on hover, white icon.
const fabSx = (bg, hover) => ({ bgcolor: bg, color: '#fff', '&:hover': { bgcolor: hover } })
